import { darken } from '@material-ui/core/styles/colorManipulator';
import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme: any) => ({
  icon: {
    margin: '0',
    width: 18,
    height: 'auto',
    fill: theme.palette.primary.contrastText
  },
  expandableTitle: {
    fontSize: '13.33px !important',

    '& div': {
      minHeight: 0,
      margin: 0
    },

    '&:hover': {
      background: darken(theme.palette.primary.main, 0.1)
    }
  },
  expandablePanel: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    margin: '0 !important',
    '&.active': {
      background: darken(theme.palette.primary.main, 0.1)
    },
    '& > div': {
      padding: '0 2px',
      minHeight: 'auto !important'
    },
    '& > div > div': {
      margin: '0 !important',
      padding: '2px 0 !important'
    }
  },
  expandableDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    padding: 2
  }
}));
